import { authDelete } from "@api/auth/auth";

import { ActionResponse } from "@pages/settings/types";
/**
 * Sends request to delete the action with id actionId
 * Recommended that you use the useDeleteAction react-query mutation instead
 */
export const deleteAction = (deploymentId: string, actionId: number) => {
  return authDelete<ActionResponse>(
    `/api/agent/deployments/${deploymentId}/actions/${actionId}`
  );
};
